export const PERMISSIONS = {
  waiter: ["take_order"],
  cashier: ["take_order", "bill", "receive_payment"],
  admin: ["take_order", "bill", "receive_payment", "void_order", "manage_employees", "open_attendance"],
  boh: ["attendance_only"],
};

export const hasPermission = (role, permission) => {
  return PERMISSIONS[role]?.includes(permission);
};
